import { css, cx } from '@emotion/css';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  AlignLeftOutlined,
  MenuOutlined,
} from '@ant-design/icons';

export const Button = React.forwardRef(
  ({ className, active, reversed, ...props }, ref) => (
    <span
      {...props}
      ref={ref}
      className={cx(
        className,
        css`
          cursor: pointer;
          color: ${reversed
            ? active
              ? 'white'
              : '#aaa'
            : active
            ? 'black'
            : 'rgb(100, 100, 100)'};
          border: ${active
            ? '1px solid rgb(100, 100, 100)'
            : '1px solid transparent'};
          border-radius: 3px;
          padding: 3px;
        `,
      )}
    />
  ),
);
// export const Icon = React.forwardRef(({ className, ...props }, ref) => (
//   <span
//     {...props}
//     ref={ref}
//     className={cx(
//       'material-icons',
//       className,
//       css`
//         font-size: 18px;
//         vertical-align: text-bottom;
//       `,
//     )}
//   />
// ));

const usableIcons = {
  format_bold: <BoldOutlined />,
  format_italic: <ItalicOutlined />,
  format_underlined: <UnderlineOutlined />,
  format_list_numbered: <OrderedListOutlined />,
  format_list_bulleted: <UnorderedListOutlined />,
  format_align_left: <AlignLeftOutlined />,
  format_align_justify: <MenuOutlined />,
};

export const Icon = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <span
      {...props}
      ref={ref}
      className={cx(
        className,
        css`
          font-size: 18px;
          vertical-align: text-bottom;
          display: inline-flex;
          align-items: center;
        `,
      )}
    >
      {usableIcons[children]}
    </span>
  ),
);

export const Instruction = React.forwardRef(({ className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={cx(
      className,
      css`
        white-space: pre-wrap;
        margin: 0 -20px 10px;
        padding: 10px 20px;
        font-size: 14px;
        background: #f8f8e8;
      `,
    )}
  />
));
export const Menu = React.forwardRef(({ className, ...props }, ref) => (
  <div
    {...props}
    data-test-id="menu"
    ref={ref}
    className={cx(
      className,
      css`
        & > * {
          display: inline-block;
        }

        & > * + * {
          margin-left: 15px;
        }
      `,
    )}
  />
));
export const Portal = ({ children }) => {
  return typeof document === 'object'
    ? ReactDOM.createPortal(children, document.body)
    : null;
};
export const Toolbar = React.forwardRef(({ className, ...props }, ref) => (
  <Menu
    {...props}
    ref={ref}
    className={cx(
      className,
      css`
        position: relative;
        padding: 1px 18px 17px;
        margin: 0 -20px;
        border-bottom: 2px solid #eee;
        margin-bottom: 20px;
      `,
    )}
  />
));
